import { render } from "./MDiscountInactive.vue?vue&type=template&id=c3255b1a&scoped=true&ts=true"
import script from "./MDiscountInactive.vue?vue&type=script&lang=ts"
export * from "./MDiscountInactive.vue?vue&type=script&lang=ts"

import "./MDiscountInactive.vue?vue&type=style&index=0&id=c3255b1a&lang=scss"
import "./MDiscountInactive.vue?vue&type=style&index=1&id=c3255b1a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3255b1a"]])

export default __exports__